import React from 'react';
import { useParams } from 'react-router';

//import defualtPlayerImg from "./../../graphics/elements/iconGroupPic.svg";
import notCaptainBadge from './../../graphics/elements/notCaptainBadge.svg';
import captainBadge from './../../graphics/elements/captainBadge.svg';
import HeaderTopic from '../../partials/HeaderTopic';
import FooterMenu from '../../partials/FooterMenu';
import BasicButtons from '../../partials/BasicButtons';
import PlayerActionButtons from './PlayerActionButtons/PlayerActionButtons';
import * as func from '../../utils/funcs';
import { rakazAssignPlayerToCaptain } from '../../api/rakazAssignPlayerToCaptain';

import styles from './PlayerInfo.module.css';
import iconProfile from './../../graphics/elements/profile_photo.svg';

function PlayerInfo(props) {
  const { user, setUser, league, teams, setTeams, players, refreshStates } =
    props;
  const { leagueId, teamId, playerId } = useParams();

  let group;

  if (teamId !== 'null') {
    group = teams.filter(team => team.id === parseInt(teamId, 10))[0];
  } else {
    group = null;
  }

  const [player, setPlayer] = React.useState(
    teamId !== 'null' && players.length > 0
      ? players.filter(player => player.user_id === parseInt(playerId, 10))[0]
      : func.userToPlayer(user)
  );

  const textGrade = numGrade => {
    if (numGrade === 4) return "ד'";
    else if (numGrade === 5) return "ה'";
    else if (numGrade === 6) return "ו'";
    else if (numGrade === 7) return "ז'";
    else if (numGrade === 8) return "ח'";
    else if (numGrade === 9) return "ט'";
    else if (numGrade === 10) return "י'";
    else if (numGrade === 11) return "יא'";
    else if (numGrade === 12) return "יב'";
    else if (numGrade === 13) return '- בוגרים';
    else return 'לא מוגדרת';
  };

  const handleClickSetCaptain = async () => {
    const res = await rakazAssignPlayerToCaptain(
      leagueId,
      teamId,
      playerId
    );
    setPlayer(res);
  };

  return (
    <div className={styles.playerInfo}>
      <HeaderTopic
        topic={leagueId !== 'undefined' ? 'ליגת ' + league.name : 'ליגות החלוץ'}
      />
      <BasicButtons user={user} refreshStates={refreshStates} />

      <FooterMenu setActive="league" />
      {func.validToGroupMembersOnPlayer(user, teamId, playerId) && player && (
        <PlayerActionButtons
          user={user}
          setUser={setUser}
          player={player}
          leagueId={leagueId}
          setTeams={setTeams}
          refreshStates={refreshStates}
        />
      )}

      <div className={styles.upperInfo}>
        <img
          src={
            player !== null &&
            player !== undefined &&
            player?.profile_pic !== null
              ? player.profile_pic
              : iconProfile
          }
          alt="תמונת השחקן"
        />
        <div>
          <h2>{player.user.full_name}</h2>
          <h3>{player.sentence}</h3>
        </div>
        {func.validRakazLeague(user) &&
          player !== null &&
          (player.status === 'captain' ? (
            <img className={styles.badge} src={captainBadge} alt="קפטן" />
          ) : (
            <img
              className={styles.badge}
              src={notCaptainBadge}
              alt="מינוי קפטן"
              onClick={handleClickSetCaptain}
            />
          ))}
      </div>
      <div className={styles.mainInfo}>
        <span>{group !== null ? group.name : 'טרם נכנס לקבוצה'}</span>
        <span>שכבה {textGrade(player.grade)}</span>
        <span>ביהס {player.school}</span>
        {func.validToGroupMembersOnPlayer(user, teamId, playerId) && (
          <>
            <span>{league && league.city_name}</span>
            <span>טלפון: {player.phone_number}</span>
            <span>
              הליגה: {league !== undefined ? league.name : 'טרם הוגדר'}
            </span>
          </>
        )}
        <span>שערים: {player.goals_count}</span>
        <span>בישולים: {player.assists_count}</span>
      </div>
    </div>
  );
}

export default PlayerInfo;
